import styled from 'styled-components';
import { space } from 'styles/variables';

export const StyledPagination = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: ${space.x3} auto;
`;
